import { Grid, InputLabel, MenuItem, Select, SelectChangeEvent, IconButton } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import "./status.select.css";
import ClearIcon from "@/assets/icons/clear-icon.svg";

interface IStatusSelect {
    value?: boolean | null;
    title: string;
    width?: string;
    updateStatus: (arg: boolean | null) => void;
}

const StatusSelect: FC<IStatusSelect> = (props: IStatusSelect) => {
    const { t } = useTranslation();
    const selectOptions = [
        { id: null, text: t("general.All") },
        { id: true, text: t("general.Active") },
        { id: false, text: t("general.Inactive") },
    ];
    return (
        <Grid className="select-status-grid">
            <InputLabel id="select-status-label">{props.title}</InputLabel>
            <Select
                id="select-status"
                labelId="select-status-label"
                className="select-status"
                label={props.title}
                sx={{ width: props.width ?? "100%" }}
                onChange={(e: SelectChangeEvent) => {
                    if (e.target.value) {
                        const option = selectOptions.find(({ text }) => text === e.target.value);
                        if (option) props.updateStatus(option.id);
                    }
                }}
                value={selectOptions.find(({ id }) => id === props.value)?.text}
                endAdornment={
                    <IconButton
                        className="select-clear-icon"
                        sx={{
                            visibility: props.value === true || props.value === false ? "visible" : "hidden",
                        }}
                        onClick={() => props.updateStatus(null)}
                    >
                        <img src={ClearIcon} alt="Clear icon" />
                    </IconButton>
                }
            >
                {selectOptions.map(({ text }) => (
                    <MenuItem key={text} value={text}>
                        {text}
                    </MenuItem>
                ))}
            </Select>
        </Grid>
    );
};

export default StatusSelect;
